import { Configuration, UsersApi } from '@/api';
import { User } from '@/models/User';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import { useQuery, useQueryClient } from '@tanstack/react-query';

const useGetUserQuery = (userId?: string) => {
  const queryClient = useQueryClient();
  const usersApi = new UsersApi(new Configuration(useAuth));

  const {
    isLoading,
    isFetching,
    data: user,
    error,
  } = useQuery<User | null>({
    queryKey: ['user', userId],
    queryFn: async () => {
      if (!userId) return null;
      const result = await usersApi.getUser(userId);
      return result || null;
    },
    enabled: Boolean(userId),
  });

  const invalidateQuery = async () => {
    return queryClient.invalidateQueries({ queryKey: ['user', userId] });
  };

  return {
    user,
    isLoading,
    isFetching,
    error,
    invalidateQuery,
  };
};

export default useGetUserQuery;
